import { useAuth } from "../app/providers/AuthProvider";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Modal from "./Modal";
import Setting from "@/features/setting/pages/Setting";
import PaymentHistory from "@/features/plan/pages/PaymentHistory";
import { LogOut, Loader2 } from "lucide-react";

import { ChevronDown, Clock8, Settings } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./DropdownMenu";

function AfterLoginHomeHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isSettingOpen, setIsSettingOpen] = useState(false);
  const [isPaymentHistoryOpen, setIsPaymentHistoryOpen] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
      setIsSettingOpen(false);
      setIsPaymentHistoryOpen(false);
      navigate("/login");
    } finally {
      setIsLoggingOut(false);
    }
  };

  if (!user) return null;

  return (
    <DropdownMenu>
      {" "}
      <div className="flex items-center space-x-2 bg-[#D4DEFD] dark:bg-[#172754] px-1 py-1 rounded-full transition-colors">
        <DropdownMenuTrigger asChild>
          <div className="flex items-center space-x-2 cursor-pointer">
            <div className="w-6 h-6 rounded-full overflow-hidden border-2 border-white">
              <img
                src={user?.user?.profilePic || `/images/avtar.png`}
                onError={(event) =>
                  (event.currentTarget.src = "/images/avtar.png")
                }
                alt="Profile"
                className="w-full h-full object-cover"
              />
            </div>{" "}
            <span className="font-medium text-gray-800 text-sm dark:text-gray-200">
              {" "}
              {user?.user?.firstName}
            </span>
            <ChevronDown
              size={16}
              className="text-gray-800 dark:text-gray-300 transition-transform duration-200"
            />
          </div>
        </DropdownMenuTrigger>
      </div>{" "}
      <DropdownMenuContent className="w-56 top-8" align="end" forceMount>
        {/* <DropdownMenuLabel>My Account</DropdownMenuLabel> */}
        {/* <DropdownMenuItem
                    onClick={() => navigate("/dashboard")}
                    className="flex items-center gap-2 px-4 py-2 text-gray-700 dark:text-gray-200 hover:bg-blue-50"
                >
                    <LayoutDashboard size={16} />
                    Dashboard
                </DropdownMenuItem> */}
        {/* <DropdownMenuSeparator /> */}
        <DropdownMenuItem
          onClick={() => setIsPaymentHistoryOpen(true)}
          className="flex items-center gap-2 px-4 py-2 text-gray-700 dark:text-gray-200 hover:bg-blue-50"
        >
          <Clock8 size={16} /> Payment History
        </DropdownMenuItem>
        {/* <DropdownMenuItem
                    onClick={() => navigate("/affiliate")}
                    className="flex items-center gap-2 px-4 py-2 text-gray-700 dark:text-gray-200 hover:bg-blue-50"
                >
                    <Crown size={16} /> Affiliate
                </DropdownMenuItem> */}
        <DropdownMenuItem
          onClick={() => setIsSettingOpen(true)}
          className="flex items-center gap-2 px-4 py-2 text-gray-700 dark:text-gray-200 hover:bg-blue-50"
        >
          <Settings size={16} /> Settings
        </DropdownMenuItem>{" "}
      </DropdownMenuContent>
      <Modal
        isOpen={isSettingOpen}
        onClose={() => setIsSettingOpen(false)}
        title={
          <div>
            <h1 className="text-xl font-bold">Settings</h1>
            <p className="text-xs font-normal text-gray-500 dark:text-gray-400 mt-0.5">
              Manage your account settings and preferences
            </p>
          </div>
        }
        size="4xl"
        showFooter={true}
        actions={[
          {
            label: (
              <div className="flex items-center gap-2">
                {isLoggingOut ? (
                  <Loader2 size={16} className="animate-spin" />
                ) : (
                  <LogOut size={16} />
                )}
                {isLoggingOut ? "Logging out..." : "Logout"}
              </div>
            ),
            color: "danger",
            onClick: handleLogout,
            disabled: isLoggingOut,
          },
        ]}
      >
        <div className="p-1">
          <Setting hideHeader={true} />
        </div>
      </Modal>
      <Modal
        isOpen={isPaymentHistoryOpen}
        onClose={() => setIsPaymentHistoryOpen(false)}
        title={
          <div>
            <h1 className="text-xl font-bold">Payment History</h1>
            <p className="text-xs font-normal text-gray-500 dark:text-gray-400 mt-0.5">
              Manage your subscriptions and download invoices
            </p>
          </div>
        }
        size="4xl"
        showFooter={false}
      >
        <div className="p-1">
          <PaymentHistory hideHeader={true} />
        </div>
      </Modal>
    </DropdownMenu>
  );
}

export default AfterLoginHomeHeader;
